import useStore from './_store';
import { mapState } from '@/store/helpers';
import { defineAsyncComponent } from 'vue';
import util from '@/common/util';
import ModuleWrapper from '@/components/module-wrapper.vue';
import BlogCategory from '@/components/blog-category/standard.vue';
import BlogPost from '@/components/blog-post.vue';
import emptyBlog from './empty-blog.vue';
import { normal } from '../defaultSpacing';
import { dateFormat } from '@/common/format';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, fetchDetail } from './asyncData';
import { sortAgentSocialNetworks } from '@/common/agents';

const ALL_BLOGS_CATEGORY_ID = 0;

const FIRST_PAGE_NUM = 1;

function timeFormatList(list) {
    return (
        list &&
        list.map(v => {
            v.publishTimeFormat =
                v.publishTime &&
                dateFormat('MMMM dd, yyyy hh:mm p', new Date(+v.publishTime), this.$pinia);
            return v;
        })
    );
}
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-blog-list'
    },
    components: {
        ModuleWrapper,
        BlogCategory,
        BlogPost,
        Pagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            )),
        emptyBlog
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        let pageNum = parseInt(this.pageLocation.query.page) || FIRST_PAGE_NUM;
        if (isNaN(pageNum)) {
            pageNum = FIRST_PAGE_NUM;
        }
        return {
            title: '',
            categoryId:  
                parseInt(this.pageLocation.query.categoryId, 10) ||
                ALL_BLOGS_CATEGORY_ID, //  Corresponding classification blog,url take it later categoryId, Without it, the default is all blogs category
            keywords: '',
            pageNum: pageNum,
            lastSearchedKeywords: null,
            sidebarTop: 0,
            defaultPagesize: 3,
            hasBlogs: true,
            ...normal
        };
    },
    computed: {
        ...mapState({
            "blogListInfo": store => store.blogListInfo,
            "shares": store => store.shares,
            "categoryTitle": store => store.categoryTitle,
            "categories": store => store.categories,
            "showCategoryCount": store => store.showCategoryCount,
            "recentPostInfo": store => store.recentPostInfo
        }),
        searchInputPlaceholder({ blogListInfo }) {
            return blogListInfo?.searchBoxTitle  || ''
        },
    },
    afterAsyncData() {
        this.hasBlogs = !!this.blogListInfo.blogs?.length;
    },
    methods: {
        ...mapAsyncData({
            fetchDetail
        }),
        outOffView(res) {
            //TODO:  set relative head height
            const offset = 80;
            //  Obtain  sidebar  high
            const height =
                (this.$refs.sidebar &&
                    this.$refs.sidebar.getBoundingClientRect().height) ||
                0;
            //  Get the height of the parent container
            const parentHeight = res.height;
            if (parentHeight < height) {
                //  Content area height less than  sidebar  then there is no need to scroll and reset  sidebar
                this.sidebarTop = 0;
                return;
            }
            // console.log('---', res, height, this.sidebarTop, parentHeight);
            if (res.top >= offset) {
                this.sidebarTop = 0;
            } else if (res.top >= height - parentHeight && res.top <= offset) {
                this.sidebarTop = -res.top + offset;
            } else {
                this.sidebarTop = parentHeight - height;
            }
        },
        getAgentInfo() {
            // TODO:  avoid  id =0  when  bug
            this.axiosIns
                .post('/api-graphql', {
                    query: `{agent(id: ${this.agentId}){fullName,image,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour},phone,position,externalUrl,license,longIntroduction,email,socialNetworks:agentSocialNetworks{id,url,socialNetwork}}}`
                })
                .then(res => {
                    const agent = (res.data && res.data.agent) || {};
                    agent.socialNetworks = sortAgentSocialNetworks(
                        agent.socialNetworks
                    );
                    this.agent = agent;
                })
                .catch(errorInfo => {
                    console.log(errorInfo);
                });
        },
        getLimitLengthText(text) {
            return text.length > 15 ? text.substring(0, 15) + '...' : text;
        },
        //TODO：  Since search does not currently support  categoryId  Use two interfaces to query , Subsequent need to merge
        pageChange(data) {
            const { page } = data;
            this.pageNum = page;
            
            if (this.keywords) {
                //  Have a search go search
                this.searchRequest(page);
            } else {
                //  Normal pagination is not performed
                this.fetchDetail();
            }
            if (this.$refs.blogs?.getBoundingClientRect) {
                let pos = this.$refs.blogs.getBoundingClientRect();
                let y = pos.top + document.documentElement.scrollTop - 100;
                if (y < 0) {
                    y = 0;
                }
                util.winScrollTop(y);
            } else if (!this.noScroll) {
                util.winScrollTop(0); // Jump to the top after turning the page
            }
        },
        submitHandler() {
            this.pageNum = FIRST_PAGE_NUM;
            if (this.keywords) {
                //  start from the first page
                this.searchRequest(FIRST_PAGE_NUM);
            } else {
                this.fetchDetail();
            }
        },
        searchRequest(pageNum) {
            this.axiosIns
                .post('/api-graphql', {
                    query: `{blogQuery(pageSize: ${this.blogListInfo.pageSize}, pageIndex: ${pageNum}, search: "${this.keywords}",categoryId: ${this.categoryId}) { count, pageIndex, pageSize, blogs{ id, name, title, author, previewPicture, previewContent, publishTime, content, url }}}`
                })
                .then(({ data }) => {
                    const { count, blogs, pageSize, pageIndex } =
                        data.blogQuery;
                    //  get list
                    this.blogListInfo.blogs = timeFormatList.call(this, blogs);
                    this.blogListInfo.pageNum = pageIndex;
                    //   Update the current page data
                    this.pageNum = pageIndex;
                    //  Calculate the total number of
                    this.blogListInfo.totalPages = Math.ceil(count / pageSize);
                    this.blogListInfo.count = count;
                    //  If it is a query and there is query content, the corresponding result will be displayed
                    if (this.keywords) {
                        //  Search and display results only if there is a search value
                        this.blogListInfo.blogListTitle = this.keywords;
                    } else {
                        this.blogListInfo.blogListTitle = '';
                    }
                });
        }
    }
};
